import { color } from '@mui/system'
import React, { Fragment } from 'react'
import { withRouter } from 'react-router-dom'
import TabsanexoComponent from './TabsanexoComponent'
import estilos from './TabsInspeccionarComponent.module.css'


function TabsEquipos(props) {


    const [tabUno, setTabUno] = React.useState(false)
    const [tabDos, setTabDos] = React.useState(false)
    const [tabTres, setTabTres] = React.useState(false)
    const [tabCuatro, setTabCuatro] = React.useState(false)

    const setearValoresUno = () => {
        setTabUno(true); setTabDos(false); setTabTres(false); setTabCuatro(false);
    }
    const setearValoresDos = () => {
        setTabUno(false); setTabDos(true); setTabTres(false); setTabCuatro(false);
    }
    const setearValoresTres = () => {
        setTabUno(false); setTabDos(false); setTabTres(true); setTabCuatro(false);
    }
    const setearValoresCuatro = () => {
        setTabUno(false); setTabDos(false); setTabTres(false); setTabCuatro(true);
    }

    React.useEffect(() => {

    }, [todo])

    return (
        <Fragment>
            <div className={`row text-center ${estilos.tabsTercerNivel} `}>
                {/**OPCIONES NIVEL 3 */}
                <div className='col-3'>
                    <button onClick={() => setearValoresUno()} type="button" className={`btn btn-light ${estilos.block}`} style={{ background: tabUno ? '#0e813c' : 'transparent', color: tabUno ? 'white' : 'black' }}>FI-25 Caratula</button>
                </div>
                <div className='col-3'>
                    <button onClick={() => setearValoresDos()} type="button" className={`btn btn-light ${estilos.block}`} style={{ background: tabDos ? '#0e813c' : 'transparent', color: tabDos ? 'white' : 'black' }}>Anexo UP</button>

                </div>            
            </div>

            {
                tabUno ? (<div className={`row text-center ${estilos.tabItem}`}>

                </div>) :
                    tabDos ? (<div className={`row text-center ${estilos.tabItem}`}>
                        <TabsanexoComponent></TabsanexoComponent>

                    </div>) :
                        <div></div>

            }

        </Fragment>
    );
};


export default withRouter(TabsEquipos)
